// extracted by mini-css-extract-plugin
export default {"subheader":"header_subheader__1yHqZ","subheaderInput":"header_subheaderInput__yGaJr","subheaderInputStateSubmissionId":"header_subheaderInputStateSubmissionId__K9Ry1"};